import React from "react";
import { SpinnerBlock } from "src/components/Spinner";

/**
 * A page, waiting.
 *
 * This drew the right mark through the wrong wrapper: antd's `Spin`, which
 * brings a wrapper element, its own `size` vocabulary and a four-dot fallback
 * of its own, and took the colour from an inline style. The mark is the
 * product's one indicator now — see `components/Spinner` — and it inherits
 * its colour like every other glyph.
 */
const Loading: React.FC = () => <SpinnerBlock size={24} inset={32} />;

export default Loading;
